<template>
 	<v-row
 		:justify = "head.justify_init"
 		:align 	 = "head.align_init"

 	>
 		<v-col
 			:cols = "head.col_init"
 		>
 			<v-card outlined>
 				<v-card-title
 					:class = "head.class_title"
 				>
 					<v-icon 
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>

					<v-spacer></v-spacer>
					<v-icon 
						small 
						color  = "primary"
						class  = "mx-2"
					>
						{{ head.icon_title }}
					</v-icon>
					<span 
						
					>
						{{ render_title }}
					</span>
					<v-spacer></v-spacer>
 				</v-card-title>
 				<v-card-text
 					:class = "head.class_text"

 				>
 					<v-progress-linear
						indeterminate
						color 	= "primary"
						v-show 	= "loading"
					></v-progress-linear>
 					<v-row 
 						dense
 					>
 							
	 					<template v-for = "(item_input, idx_input) of list_fields">
	 						<v-col
	 							:cols = "item_input.col"
	 							:key  = "ref + idx_input"
	 						>
	 							<v-text-field
	 								dense
	 								outlined
	 								hide-details

	 								v-if 			= "['text', 'number'].includes(item_input.type)"
	 								:type 			= "item_input.type"
	 								:class 			= "item_input.class"
	 								:label 			= "item_input.text"
	 								v-model 		= "info[item_input.key]"
	 								:placeholder 	= "item_input.placeholder"
	 								:readonly 		= "disableds[item_input.key]"
	 							>
	 								<template v-slot:prepend-inner>
	 										<!-- small -->
	 									<v-icon
	 										:color = "item_input.color"
	 										:class = "item_input.class_icon"
	 									>
	 										{{ item_input.prepend_icon }}	
	 									</v-icon>
	 								</template>
	 								<template v-slot:append>
	 									<v-tooltip
	 										top
	 									>	
	 										<template v-slot:activator = "{ on }">
	 											
			 									<v-btn
			 										fab
			 										small
			 										v-show = "item_input.btn_edit && show.edit_idTelegram"
				 									:color = "disableds[item_input.key] ?  'primary' : 'secondary'"
				 									height = "25"
				 									width  = "25"
				 									v-on   = "on"
				 									@click = "actions(item_input.btn_action)"
			 									>
			 										
				 									<v-icon
				 										small
				 										class = "pa-0 ma-0"
				 									>
				 										mdi-pencil	
				 									</v-icon>
			 									</v-btn>
	 										</template>
	 										<span>
	 											{{ item_input.tooltip }}
	 										</span>
	 									</v-tooltip>
	 								</template>
	 							</v-text-field>
	 						
		 						<v-card 
									outlined 
									class 		= "pa-0 caption " 
									height 		= "40"
									
									v-if 	= "item_input.type == 'switch'">
									<v-switch			
										dense						
										hide-details
										:class 			= "item_input.class"			
										v-model 		= "info[item_input.key]"									
										:label 			= "item_input.text"
										:prepend-icon 	= "item_input.prepen_icon"
										:true-value 	= "item_input.value"
									></v-switch>
										
								</v-card>
								<v-select
									dense						
									outlined
									hide-details
									v-else-if 			= "item_input.type == 'select'"
									v-model 			= "info[item_input.key]"
									:label 				= "item_input.text"
									:items 				= "render_listeds(item_input.list)"
									:item-text 			= "item_input.item_text"
									:item-value 		= "item_input.item_value"
									:prepend-inner-icon = "item_input.prepend_icon"
								></v-select>
	 						</v-col>
	 					</template>
 					</v-row>
 				</v-card-text>
 				<v-divider></v-divider>
 				<v-card-actions>
 					<v-spacer></v-spacer>
 					<v-btn
 						x-small
 						:color = "head.class_btn"
 						@click = "actions(head.btn_action)"
 					>
 						{{ $ml.get(head.btn_action) }}
 					</v-btn>
 				</v-card-actions>
 			</v-card>
 		</v-col>
 	</v-row>
</template>
<script type="text/javascript">
 	export default {
 		name : "contact",
 		data : (vm) => ({
 			ref 		: "contact",
 			info 		: {},
 			info_item 	: null,
 			head 		: {
 				justify_init	: "center",
				align_init 		: "end",
				col_init		: "5",
				class_title 	: "justify-center body-1 secondary pa-1 white--text",
				title 			: vm.$ml.get("new_contact"),
				icon_title 		: "mdi-contacts",
				class_text 		: "pa-2 ",
				btn_action 		: "save",
				class_btn 		: "primary",


 			},
 			disableds 	: {
 				idTelegram : true,
 			},
 			show 		: {
 				edit_idTelegram : true,
 			},
 			list_fields		: [
 				{
					key 			: "name",
					text 			: vm.$ml.get("name"),
 					type 			: "text",
 					class 			: "",
					placeholder 	: vm.$ml.get("contact"),
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-account-box",
					col 			: "12",
 				},
 				{
					key 			: "type_contact",
					text 			: vm.$ml.get("type_of_contact"),
 					type 			: "select",
 					class 			: "",
					placeholder 	: vm.$ml.get("contact"),
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-account-box",
					list 			: "types_contacts",
					item_text   	: "text",
					item_value 		: "key",
					col 			: "12",
 				},
 				{
					key 			: "email",
					text 			: vm.$ml.get("email"),
 					type 			: "text",
 					class 			: "",
					placeholder 	: "example@email.com",
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-email",
					col 			: "8",
 				},
 				/*{
					key 			: "isEmail",
					text 			: vm.$ml.get("send_email"),
 					type 			: "switch",
 					class 			: "mt-1 ml-1",
					placeholder 	: "",
					color 			: "",
					class_icon 		: "",
					prepend_icon 	: "",
					col 			: "4",
					value 			: true,
 				},*/
 				{
					key 			: "cellphone",
					text 			: "cellphone",
 					type 			: "number",
 					class 			: "",
					placeholder 	: "300-XXX-XXXX",
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-cellphone",
					col 			: "8",
 				},
 				/*{
					key 			: "isWs",
					text 			: vm.$ml.get("send_ws"),
 					type 			: "switch",
 					class 			: "mt-1 ml-1",
					placeholder 	: "",
					color 			: "",
					class_icon 		: "",
					prepend_icon 	: "",
					col 			: "4",
 				},*/
 				{
					key 			: "idTelegram",
					text 			: vm.$ml.get("telegram"),
 					type 			: "text",
 					class 			: "",
					placeholder 	: "@XXXXX:##### " + vm.$ml.get("is_created_automatically"),
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-send",
					col 			: "8",					
					btn_edit  		: true,
					btn_action 		: "edit_telegram",
					tooltip 		: vm.$ml.get("edit")
 				},
 				{
					key 			: "isTelegram",
					text 			: vm.$ml.get("send_telegram"),
 					type 			: "switch",
 					class 			: "mt-1 ml-1",
					placeholder 	: "",
					color 			: "",
					class_icon 		: "",
					prepend_icon 	: "",
					col 			: "4",

 				},
 				
 				

 			],
 			bus 			: {},
 			loading 		: false,
 			types_contacts  : [
 				{
 					key  : "final_client",
 					text : vm.$ml.get("final_client"),
 				},
 				{
 					key  : "alert_monitor",
 					text : vm.$ml.get("alert_monitor"),
 				}
 			]
 			

 		}), // data

 		created(){

 		}, // created

 		computed : {
 			render_title: function(){
 				this.render_info();
 				if (this.$route.name == "new_contact"){
 					this.head.btn_action 	= "save"; 
 					return this.head.title 	= this.$ml.get("new_contact");

 				}else{
 					this.head.btn_action 	= "update";  					
 					return this.head.title 	= this.$ml.get("settings_contact");
 				}

 			}, // render title

 		}, // computed

 		methods : {
 			actions(act, item, opt){ 					
 				if (act == "save") {
 					this.save();
 				}else
 				if (act == "update") {
 					this.update();
 				}else
 				if (act == "edit_telegram") {
 					this.disableds.idTelegram = !this.disableds.idTelegram;


 				}
 			}, // actions

 			render_info(){
 				let temp = this.$Helper.get_local("settings_contact");
 				if (temp && temp.type != "new") {
 					this.info = { ...temp };
 					if (this.$store.getters["auth/permission"](this.$route.name || "contacts", "can_edit", "contacts")) {
 						this.show.edit_idTelegram = true;
 						this.disableds.idTelegram = true; // disabled
 					}else{
 						this.show.edit_idTelegram = false;
 						this.disableds.idTelegram = true;
 					}
 				}else{
 					if (this.$store.getters["auth/permission"](this.$route.name || "contacts", "can_add", "contacts")) {
 						this.show.edit_idTelegram = true;  
 						this.disableds.idTelegram = false; // enable
 					}else{
 						this.show.edit_idTelegram = false;
 						this.disableds.idTelegram = true;
 					}
 				}
 			}, // render info

 			render_listeds(list){
 				if (list && this[list]) {
 					return this[list];
 				}
 			}, // render listed

 			save(){
 				if (!this.$store.getters["auth/permission"](this.$route.name || "contacts", "can_add", "contacts")) {
 					this.$EventBus.$emit("notifications_modal",{
 						type 	: "warning",
 						message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get("new_contact") 
 					})

 					return false
 				}
 				const api 			= this.$URL + "/api/v1/contacts";
 				let info_up 		= { ...this.info };
 				info_up["state"] 	= true;
 				this.loading 	= true;
 				this.$axios.post(api, info_up).then(res => {
 					this.loading 	= false;
 					this.info 		= {};
 					this.$EventBus.$emit("notifications_modal",{
	 						type : "saved",
	 					})
 					this.$router.back();
 				}).catch(er => {
 					this.loading 	= false;
 					console.warn("Error create contact : ", er)
 					this.$EventBus.$emit("notifications_modal",{
 						type 	: "error",
 						message : er
 					})
 				})
 			}, // save

 			update(){
 				if (!this.$store.getters["auth/permission"](this.$route.name || "contacts", "can_edit", "contacts")) {
 					this.$EventBus.$emit("notifications_modal",{
 						type 	: "warning",
 						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings_contact") 
 					})

 					return false
 				}
 				let info_up 	= { ...this.info };
 				console.log("CHEK INFO : ", info_up)
 				if (info_up && info_up.id) {

	 				const api 		= this.$URL + "/api/v1/contacts/" + info_up.id;
	 				this.loading 	= true;
	 				this.$axios.put(api, info_up).then(res => {
	 					this.loading 	= false;
	 					this.info 		= {};
	 					this.$EventBus.$emit("notifications_modal",{
	 						type : "updated",
	 					})
	 					this.$router.back();
	 				}).catch(er => {
	 					this.loading 	= false;
	 					console.warn("Error create contact : ", er)
	 					this.$EventBus.$emit("notifications_modal",{
	 						type 	: "error",
	 						message : er
	 					})
	 				})
 				}else{
 					console.warn("Required ID for update contact ", info_up)
 				}
 			}, // update

 			

 		}, // methods

 		beforeDestroy(){
 			this.$Helper.clear_bus(this.$EventBus, this.bus, "contact");
 		}
 	}
</script>